<template lang="pug">
//- LOADING PAGE
transition(name="fade")
  .loading-wrapper(v-if="isVisible")
    .loading
      img.loading-player(src="@/assets/images/gv-oedu@3x.png")
</template>
<script>
export default {
  name: 'Loading',
  props: {
    isVisible: {
      type: Boolean,
      default: true
    }
  },
  components: {
  },
  computed: {

  },
  created () {
  },
  data () {
    return {
    };
  }
}
</script>
